import styled from "@emotion/styled";
import isEmpty from "lodash/isEmpty";
import { SearchInput } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { FilterByTags } from "@kaltura/mediaspace-shared-types";
import Filters from "./filters/Filters";
import Bubbles, { FiltersValues } from "./bubbles/Bubbles";
import { ChangeEvent, KeyboardEvent } from "react";

export interface FilterBarProps {
    onInputChange?: (value: string) => void;
    onInputSubmit?: (value: string) => void;
    onInputReset?: () => void;
    onFilterChange: (param: string, values: string[]) => void;
    onClearBubbles: () => void;
    dateFilter?: FilterByTags;
    filters?: FilterByTags[];
    values?: FiltersValues;
    showInputClearButton?: boolean;
    withSearchInput?: boolean;
    searchInputPlaceholder?: string;
}

const StyledFilterBar = styled("div")(({ theme }) => ({
    width: "100%",
}));

const StyledFiltersLine = styled("div")(({ theme }) => ({
    width: "100%",
    [theme.breakpoints.up("sm")]: {
        display: "flex",
        justifyContent: "space-between",
    },
}));

const StyledBubbles = styled(Bubbles)(({ theme }) => ({
    marginTop: theme.spacing(2),
}));

const StyledSearchInput = styled(SearchInput)(({ theme }) => ({
    width: "100%",
    [theme.breakpoints.up("sm")]: {
        width: 184,
    },
    [theme.breakpoints.up("md")]: {
        width: 200,
    },
}));

/**
 * Sessions Filter Bar
 */
export function FilterBar(props: FilterBarProps) {
    const {
        onInputChange,
        onInputReset,
        onFilterChange,
        onClearBubbles,
        filters,
        values = {},
        onInputSubmit,
        showInputClearButton = true,
        withSearchInput = true,
        searchInputPlaceholder,
    } = props;

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        onInputChange?.(event.target.value);
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (!onInputSubmit || event.key !== "Enter") {
            return;
        }

        onInputSubmit((event.target as HTMLInputElement).value);
    };

    return (
        <StyledFilterBar className="kms-ds-agenda-filter-bar">
            <StyledFiltersLine>
                {withSearchInput && (
                    <StyledSearchInput
                        showIcon={true}
                        showClearButton={showInputClearButton}
                        placeholder={searchInputPlaceholder || translate("Search")}
                        color={"primary"}
                        onInputChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        onReset={onInputReset}
                    />
                )}
                <Filters filters={filters} values={values} onFilterChange={onFilterChange} />
            </StyledFiltersLine>
            {!isEmpty(values) && (
                <StyledBubbles values={values} onChange={onFilterChange} onClearBubbles={onClearBubbles} />
            )}
        </StyledFilterBar>
    );
}

export default FilterBar;
